// extracted by mini-css-extract-plugin
module.exports = {"AnimatedButton":"AnimatedButton_AnimatedButton__N5Y6N","Danger":"AnimatedButton_Danger__ludng","enable":"AnimatedButton_enable__1G_AO"};